import { useLocation } from 'react-router-dom';
import { PageSidebar, type PageSidebarSection } from '@/components/ui/page-sidebar';
import { ShoppingBasket, Truck } from 'lucide-react';

export default function ECommerceLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = useLocation().pathname;

  // Only show sidebar for orders and shipments pages
  const showSidebar = pathname === '/e-commerce/orders' || pathname === '/e-commerce/shipments';

  if (!showSidebar) {
    return children;
  }

  const sidebarItems: PageSidebarSection[] = [
    {
      items: [
        { label: 'Orders', url: '/e-commerce/orders', icon: ShoppingBasket },
        { label: 'Shipments', url: '/e-commerce/shipments', icon: Truck },
      ],
    },
  ];

  return (
    <div className="flex h-full w-full">
      <PageSidebar sections={sidebarItems} />
      <div className="flex flex-col flex-1 min-w-0">{children}</div>
    </div>
  );
}
